import React, { useState, useMemo, useCallback, useRef } from 'react';

import { loginToGoogle, sendEmail, loginToDiscord } from '@shakkerai/services';
import { TextInput, Button, Loader } from '@mantine/core';
import { getCookieWebid } from '@shakkerai/util-cookie';
import iconDiscord from './discord.png';
import iconEmail from './email.svg';
import iconGoogle from './google.svg';
import { encode } from '@shakkerai/pro-utils';
import { metaReport } from '@shakkerai/util-meta-report';
import Captcha from './Captcha';
const notifyError = (msg) => console.log(msg);

const reportMIQ = () => {
  var axel = Math.random() + '';
  var a = axel * 10000000000000;
  var img = document.createElement('img');
  img.src = 'https://12345678.fls.doubleclick.net/activityi;src=12345678;type=conve0;cat=exampl0;ord=' + a + '?';
  img.width = 1;
  img.height = 1;
  img.style.borderStyle = 'none';
  document.body.appendChild(img);
};

const REG_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/* eslint-disable */
const Email = () => {
  const [email, setEmail] = useState('');
  // 暂时不校验，后期会加上，先留着
  // const [agreementChecked, setAgreementChecked] = useState(false);
  const [isEmailCheck, setEmailCheck] = useState(false);
  const [isEmailSend, setIsEmailSend] = useState(false);
  const [disable, setDisable] = useState(false);
  const emailInputRef = useRef();
  const isEmailOk = useMemo(() => {
    if (!email) {
      return false;
    }

    if (!REG_EMAIL.test(email)) {
      return false;
    }

    return true;
  }, [email]);

  // const getEmailCode = async () => {
  //   setEmailCheck(true);
  //   if (disable) return;
  //   if (isEmailOk) {
  //     setDisable(true);
  //     const cid = getCookieWebid();
  //     const res = await sendEmail({ email, cid, redirectUrl: encode(window.location.href) });
  //     if (!res.code) {
  //       setIsEmailSend(true);
  //     } else {
  //       notifyError(res.msg);
  //       setDisable(false);
  //     }
  //   }
  //   reportMIQ();
  //   metaReport('login');
  // };
  const getEmailCode = useCallback(
    async (captchaVerifyParam) => {
      if (disable || !isEmailOk) return;

      setEmailCheck(true);
      setDisable(true);
      const cid = getCookieWebid();

      try {
        const res = await sendEmail({
          captchaVerifyParam,
          email: emailInputRef.current?.value,
          cid,
          redirectUrl: encode(window.location.href),
        });

        if (res.code === 0) {
          setIsEmailSend(true);
        } else {
          notifyError(res.msg);
          setDisable(false);
        }
        reportMIQ();
        metaReport('login');

        return {
          captchaResult: res.code === 0, // 验证码验证是否通过，boolean类型，必选
          bizResult: res.code === 0, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
        };
      } catch (error) {
        return {
          captchaResult: false, // 验证码验证是否通过，boolean类型，必选
          bizResult: false, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
        };
      }
    },
    [isEmailOk],
  );

  return isEmailSend ? (
    <div className="flex flex-col items-center">
      <img src={iconEmail} alt="login icon email" className="w-12 h-12" />
      <div className="text-primary text-lg font-medium text-center leading-7">{'Check your Email on computer'}</div>
      <div className="text-[#dadada] text-xs px-7 font-semibold text-center">
        {'We have sent a login link to your Email Address. If you don’t get the email, please check your spam folder'}
      </div>
    </div>
  ) : (
    <div>
      <TextInput
        ref={emailInputRef}
        className={`w-[302px] h-[48px] mx-auto rounded-md mb-6 placeholder:text-[#414141] border-[#9B9B9B] text-white`}
        maxLength={50}
        styles={{
          wrapper: { width: '100%' },
          input: { color: '#fff', height: '46px', backgroundColor: 'rgb(37, 38, 43)' },
        }}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
        onFocus={() => {
          setEmailCheck(false);
        }}
        error={Boolean(isEmailCheck && !isEmailOk) ? 'error' : ''}
        inputWrapperOrder={['input']}
        placeholder={'username@shakker.ai'}
      />
      <Button
        id="emailLogin"
        onClick={() => {
          if (isEmailOk) {
            return;
          }
          setEmailCheck(true);
        }}
        type="primary"
        disabled={disable}
        className={
          'w-[302px] h-[44px] text-black font-bold rounded-md mb-2.5 flex items-center justify-center mx-auto px-8 cursor-pointer hover:opacity-90 bg-gradient-to-b from-[#01fff0] to-[#38ffdc]'
        }
      >
        {disable ? <Loader color="#101010" size="16px" className="mr-2" /> : null}
        {'NEXT'}
      </Button>
      {isEmailOk ? <Captcha captchaCallback={getEmailCode} /> : null}
      <div className="flex items-center justify-center leading-4 text-[#999] text-[10px]">
        <div>
          By continuing you agree to the{' '}
          <a href="/aigenerator/index#/document/aiUserAgreement" target="_blank" className="text-primary font-semibold">
            {'Terms of Use'}
          </a>{' '}
          and{' '}
          <a href="/aigenerator/index#/document/aiPrivacyPolicy" target="_blank" className="text-primary font-semibold">
            {'Privacy Policy'}
          </a>
        </div>
      </div>
    </div>
  );
};

export const ShakkerLoginModal = () => {
  const cid = getCookieWebid();
  const redirectUrl = encode(window.location.href);
  return (
    <div className="bg-[#141414] rounded-3xl w-[380px] py-[30px] px-[20px]">
      <h2 className="text-center text-white font-bold mb-7 text-xl">{'Sign in your Shakker account'}</h2>
      <div
        id="discordLogin"
        className={
          'w-[302px] h-[48px] rounded-md mb-2.5 flex items-center justify-center mx-auto px-8 cursor-pointer hover:opacity-90 bg-[#7681f1]'
        }
        onClick={() => {
          const params = {
            redirectUrl,
            cid,
          };
          loginToDiscord(params).then((res) => {
            if (res.data) {
              window.open(res.data, '_self');
            }
          });
          reportMIQ();
          metaReport('login');
        }}
      >
        <img alt="login icon discord" className="w-[29px] h-[22px] mr-1.5" src={iconDiscord} />
        <span className="text-white text-lg font-bold">{'Discord'}</span>
      </div>
      <div
        id="googleLogin"
        className={
          'w-[302px] h-[48px] rounded-md mb-2.5 flex items-center justify-center mx-auto px-8 cursor-pointer hover:opacity-90 bg-[#535353]'
        }
        onClick={() => {
          const params = {
            redirectUrl,
            cid,
          };
          loginToGoogle(params).then((res) => {
            if (res.data) {
              window.open(res.data, '_self');
            }
          });
          reportMIQ();
          metaReport('login');
        }}
      >
        <img alt="login icon discord" className="w-[27px] h-[27px] mr-1.5" src={iconGoogle} />
        <span className="text-white text-lg font-bold">{'Google'}</span>
      </div>
      <div className="flex items-center justify-center h-16">
        <span className="w-14 h-[1px] bg-[#606060]"></span>
        <span className="text-sm text-[#606060] mx-3">{'Or, sign up with Email'}</span>
        <span className="w-14 h-[1px] bg-[#606060]"></span>
      </div>
      <Email />
    </div>
  );
};
